import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/app/use-theme";
import { cn } from "@/platform/lib/cn";

const options = [
  { value: "light", icon: Sun, label: "Tema claro" },
  { value: "dark", icon: Moon, label: "Tema escuro" },
] as const;

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Seleção de tema"
      className="inline-flex h-8 items-center gap-0.5 rounded-full border border-[--color-border] bg-[color:var(--color-card)] p-0.5"
    >
      {options.map(({ value, icon: Icon, label }) => {
        const active = theme === value;
        return (
          <button
            key={value}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={label}
            onClick={() => setTheme(value)}
            className={cn(
              "grid place-items-center h-7 w-7 rounded-full transition-colors duration-150 ease-out",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[--color-ring]",
              active
                ? "bg-[color:var(--color-foreground)] text-[color:var(--color-background)]"
                : "text-[color:var(--color-muted-foreground)] hover:text-[color:var(--color-foreground)]",
            )}
          >
            <Icon className="size-3.5" aria-hidden />
          </button>
        );
      })}
    </div>
  );
}
